// extracted by mini-css-extract-plugin
export default {"tags":"tags---NIO6H","tagsIcon":"tagsIcon---syMKx"};